import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EndpointService {
  static readonly PAYER_ORG_HEADER = 'X-Payer-Organization';
  private payerOrgIdentifier = '';
  private proxyBase = '';

  setContext(payerOrgIdentifier: string, proxyBaseUrl: string): void {
    this.payerOrgIdentifier = payerOrgIdentifier;
    this.proxyBase = proxyBaseUrl;
  }

  getPayerOrgIdentifier(): string {
    return this.payerOrgIdentifier;
  }

  getProxyBase(): string {
    return this.proxyBase;
  }

  getQuestionnairePackageUrl(): string {
    return `${this.proxyBase}Questionnaire/$questionnaire-package`;
  }

  getCdsServicesUrl(): string {
    return `${this.proxyBase}cds-services`;
  }

  getPasSubmitUrl(): string {
    return `${this.proxyBase}Claim/$submit`;
  }

  getCdexAttachmentUrl(): string {
    return `${this.proxyBase}$submit-attachment`;
  }

  getPopulateUrl(): string {
    return `${this.proxyBase}Questionnaire/$populate`;
  }

  getNextQuestionUrl(): string {
    return `${this.proxyBase}Questionnaire/$next-question`;
  }

  getLogErrorUrl(): string {
    return `${this.proxyBase}Questionnaire/$log-questionnaire-errors`;
  }
}
